import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Empty, Modal } from "antd";
import ReactRouterPrompt from "react-router-prompt";
import { useTranslation } from "../../others/i18n.js";
const ReactRouterPromptWrapper = ({ when, title, message })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(ReactRouterPrompt, {
        when: when,
        children: ({ isActive, onConfirm, onCancel })=>/*#__PURE__*/ _jsxs(Modal, {
                open: isActive,
                onCancel: onCancel,
                onOk: onConfirm,
                title: title || t("Leave now?"),
                centered: true,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(Empty, {
                            description: false
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            textAlign: "center"
                        },
                        children: message || t("Finished? Your changes will not be saved.")
                    })
                ]
            })
    });
};
export { ReactRouterPromptWrapper };
